// Gradient colors schema
// Three-color gradient configuration for diagram coloring
// Source: C++ gradient_colors struct

import { z } from 'zod';
import { RgbaSchema } from '../base/common';

// --- Color Criteria Enum (29 values) ---

export const ColorCriteriaSchema = z.enum([
  'messages', 'velocity', 'hydraulic_grade', 'pressure_drop', 'head_loss',
  'pipe_length', 'reynolds_number', 'flow_rate', 'vf_pressure_drop', 'vf_head_loss',
  'valve_position', 'pressure', 'elevation', 'pipe_specification', 'fluid_zone',
  'pipe_size', 'pipe_k', 'fluid_temperature', 'dp_per_100', 'hl_per_100',
  'heat_transfer_rate', 'design_status', 'mach_number', 'dp_water_hammer', 'power',
  'custom_string', 'custom_bool', 'custom_int', 'custom_double',
]);

export type ColorCriteria = z.infer<typeof ColorCriteriaSchema>;

// --- Three-color gradient (min -> mid -> max) ---

export const GradientSchema = z.object({
  minimum: RgbaSchema,
  middle: RgbaSchema,
  maximum: RgbaSchema,
});

export type Gradient = z.infer<typeof GradientSchema>;

// --- User-defined value range for gradient mapping ---

export const GradientRangeSchema = z.object({
  min: z.number().optional(),
  max: z.number().optional(),
});

export type GradientRange = z.infer<typeof GradientRangeSchema>;

// --- Document-level gradient colors container ---

export const GradientColorsSchema = z.object({
  /** Currently active color criteria */
  criteria: ColorCriteriaSchema,
  /** String representation of the criteria */
  criteria_string: z.string(),
  /** Display name of the selected criteria */
  selected_criteria_name: z.string(),
  /** Per-criteria three-color gradients (sparse — not all criteria need entries) */
  gradients: z.record(z.string(), GradientSchema),
  /** Per-criteria user-defined value ranges (sparse — not all criteria need entries) */
  ranges: z.record(z.string(), GradientRangeSchema),
});

export type GradientColors = z.infer<typeof GradientColorsSchema>;
